import React from 'react';

import styles from './CompetitionsPage.module.css';

type Props = {
  children: React.ReactNode;
};

export const CompetitionsPageTemplate: React.FC<Props> = ({ children }) => (
  <div className={styles.CompetitionsPage__Template}>{children}</div>
);
